import React, { useState, useContext, createContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-query";
import * as auditService from "api/services/auditService";

const LastAuditedYearContext = createContext(0);

const useLastAuditedYearContext = () => useContext(LastAuditedYearContext);

const LastAuditedYearProvider = ({ children }) => {
  const { data: backendData, refetch } = useQuery(
    "lastAuditedYear",
    () => auditService.getLastAuditedYear(),
    {
      staleTime: 24 * 60 * 60 * 1000,
      initialData: 0,
    }
  );

  const [lastAuditedYear, setLastAuditedYear] = useState(backendData);

  useEffect(() => {
    setLastAuditedYear(backendData);
  }, [backendData]);

  return (
    <LastAuditedYearContext.Provider
      value={{
        lastAuditedYear,
        refetchLastAuditedYear: refetch,
      }}
    >
      {children}
    </LastAuditedYearContext.Provider>
  );
};

LastAuditedYearProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { useLastAuditedYearContext, LastAuditedYearProvider };
